import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpService from "../../services/httpService";
import { notify } from "../utils/methods/notification";


const initialState = {
    isLoading: false,
    allLabel: [],
    addModal: false,
};
export const fetchAlllabel = createAsyncThunk(
    'bmr/fetchAlllabel',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/master-data-get', { params: payload });
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const addLabel = createAsyncThunk(
    'bmr/addLabel',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await httpService.post('/master-data', args);
            notify.success(response?.data?.message || response?.message || "Label added successfully");
            dispatch(disableAddModal());
            dispatch(fetchAlllabel({ page: 1, per_page: 10 }));
            return response.data;
        } catch (error) {
            const errorMessage = error ||
                error?.[0]?.api_url ||
                error?.message ||
                "Something went wrong";
            notify.error(errorMessage);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const deleteMasterData = createAsyncThunk(
    'masterData/deleteMasterData',
    async (args, { rejectWithValue }) => {
        try {
            const { id } = args;
            const response = await httpService.delete(`/master-data-delete/${id}`);
            notify.success(response?.data?.message || "Data deleted successfully");
            return response.data;
        } catch (error) {
            const errorMessage = error ||
                error?.[0]?.api_url ||
                error?.message ||
                "Something went wrong";
            notify.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateLabel = createAsyncThunk(
    'label/updateLabel',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { editId, data } = args;
            const response = await httpService.put(`/master-data-update/${editId}`, data);
            notify.success(response?.data?.message || response?.message || "Label updated successfully");
            dispatch(disableAddModal());
            dispatch(fetchAlllabel({ page: 1, per_page: 10 }));
            return response.data;
        } catch (error) {
            const errorMessage =
                error?.[0]?.api_url ||
                error?.message ||
                "Something went wrong";
            notify.error(errorMessage);
            return rejectWithValue(error?.response ? error.response.data : error.message);
        }
    }
);
const bmrfbMasterSlice = createSlice({
    name: 'bmrFormBuilderMaster',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlllabel.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAlllabel.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLabel = action.payload
            })
            .addCase(fetchAlllabel.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteMasterData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteMasterData.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteMasterData.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(updateLabel.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateLabel.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.currentLabel?.id === action.payload.id) {
                    state.currentLabel = action.payload;
                }
            })
            .addCase(updateLabel.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(addLabel.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addLabel.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addLabel.rejected, (state) => {
                state.isLoading = false;
            })
    }
})
export const { enableAddModal, disableAddModal } = bmrfbMasterSlice.actions;
export default bmrfbMasterSlice.reducer;